import React from "react";
import { ArrowUpRight } from "lucide-react";
import { usePrice } from "@/lib/price";

export default function Community() {
  const { price } = usePrice();
  return (
    <section
      id="comm"
      data-testid="community"
      className="border-b-4 border-[#0a0a0a] bg-[#FFE600] scroll-mt-24"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="mb-10 md:mb-14 reveal">
          <div className="font-accent text-sm bg-[#0055FF] text-white inline-block px-3 py-1 mb-4">
            COMMUNITY
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl">
            A community that{" "}
            <span className="bg-[#0a0a0a] text-[#FFE600] px-2">ships.</span>
          </h2>
          <p className="font-mono-body mt-5 max-w-2xl text-[#0a0a0a]/85 text-base md:text-lg">
            Grounded, no hype — members already running the system, posting
            receipts, asking sharp questions. No gurus.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <a
            href="https://whop.com/jobhacki/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="comm-whop"
            className="hover-pop block bg-white border-4 border-[#0a0a0a] shadow-brutal p-7 md:p-8 group"
          >
            <div className="flex items-start justify-between mb-5">
              <div className="flex items-center gap-3">
                <div className="w-14 h-14 bg-white border-4 border-[#0a0a0a] flex items-center justify-center overflow-hidden p-2">
                  <img
                    src="/whop-logo.png"
                    alt="Whop"
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      e.currentTarget.src = "https://icon.horse/icon/whop.com";
                    }}
                  />
                </div>
                <div>
                  <div className="font-display text-2xl">Whop</div>
                  <div className="font-mono-body text-xs text-[#0a0a0a]/60">
                    Live · 1,762 members inside
                  </div>
                </div>
              </div>
              <span className="font-accent text-[10px] bg-[#00FF66] text-[#0a0a0a] border-2 border-[#0a0a0a] px-2 py-1">
                LIVE
              </span>
            </div>
            <p className="font-mono-body text-[14px] leading-relaxed">
              Where the system runs day-to-day. Receipts, playbook discussion,
              builder support, monthly drops.
            </p>
            <div className="mt-6 flex items-center gap-4 font-mono-body text-xs">
              <span>
                <span className="font-bold">4.9★</span> rating
              </span>
              <span>·</span>
              <span>1,700+ members</span>
              <ArrowUpRight
                size={16}
                strokeWidth={3}
                className="ml-auto opacity-60 group-hover:opacity-100"
              />
            </div>
          </a>

          <div
            data-testid="comm-skool"
            className="bg-white border-4 border-[#0a0a0a] shadow-brutal p-7 md:p-8 relative"
          >
            <span className="absolute top-5 right-5 font-accent text-[10px] bg-[#0a0a0a] text-[#FFE600] border-2 border-[#0a0a0a] px-2 py-1">
              SOON
            </span>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-14 h-14 bg-white border-4 border-[#0a0a0a] flex items-center justify-center overflow-hidden p-2">
                <img
                  src="/skool-logo.png"
                  alt="Skool"
                  className="w-full h-full object-contain"
                  onError={(e) => {
                    e.currentTarget.src = "https://icon.horse/icon/skool.com";
                  }}
                />
              </div>
              <div>
                <div className="font-display text-2xl">Skool</div>
                <div className="font-mono-body text-xs text-[#0a0a0a]/60">
                  Cohort & courses layer
                </div>
              </div>
            </div>
            <p className="font-mono-body text-[14px] leading-relaxed text-[#0a0a0a]/75">
              For deeper, structured pushes — guided playbook cohorts and
              build-along sprints. Drops next.
            </p>
            <div className="mt-6 font-mono-body text-xs text-[#0a0a0a]/60">
              Joining when it ships? Already included in your {price}.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
